export default "__VITE_ASSET__BQAS8YP5__"